import { NavLink, useLocation } from 'react-router-dom';
import { IngestKeysView } from '@/features/ai-dart/views/settings/IngestKeysView';
import { OrchestratorsView } from '@/features/ai-dart/views/settings/OrchestratorsView';
import { ReposView } from '@/features/ai-dart/views/settings/ReposView';
import { SchedulesView } from '@/features/ai-dart/views/settings/SchedulesView';
import { SourcesView } from '@/features/ai-dart/views/settings/SourcesView';

const TABS = [
  { path: 'orchestrators', label: '모델', element: OrchestratorsView },
  { path: 'sources', label: '인커밍 어댑터', element: SourcesView },
  { path: 'repos', label: '레포/브랜치', element: ReposView },
  { path: 'schedules', label: '스케줄', element: SchedulesView },
  { path: 'ingest-keys', label: '인입 키', element: IngestKeysView },
];

export function SettingsLayout(): React.JSX.Element {
  const { pathname } = useLocation();
  const active = TABS.find((tab) => pathname.endsWith(`/${tab.path}`)) ?? TABS[0];
  const View = active.element;
  return <div className="space-y-4"><header><h1 className="text-xl font-bold">AI-DART 설정</h1><p className="text-[12px] text-muted">파이프라인 정책과 외부 연동 자격증명을 관리합니다.</p></header>
    <nav className="flex flex-wrap gap-1 border-b border-line">{TABS.map((tab) => <NavLink key={tab.path} to={`/ai-dart/settings/${tab.path}`} className={({ isActive }) => `border-b-2 px-3 py-2 text-[12px] ${isActive ? 'border-accent font-semibold text-accent' : 'border-transparent text-muted'}`}>{tab.label}</NavLink>)}</nav>
    <View />
  </div>;
}
